import { render, staticRenderFns } from "./task-profile.vue?vue&type=template&id=b03d0416&scoped=true"
import script from "./task-profile.vue?vue&type=script&lang=js"
export * from "./task-profile.vue?vue&type=script&lang=js"
import style0 from "./task-profile.vue?vue&type=style&index=0&id=b03d0416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03d0416",
  null
  
)

export default component.exports